function stickyHeader() {
	var navWrapper = document.querySelector('.main-nav__wrapper');

	if (navWrapper) {
		window.addEventListener('scroll', function() {
			if (window.scrollY > 0) {
				navWrapper.classList.add('main-nav__wrapper--solid', 'main-nav__wrapper--solid-shadow');
			} else {
				navWrapper.classList.remove('main-nav__wrapper--solid', 'main-nav__wrapper--solid-shadow');
			}
		});
	}
}

export { stickyHeader };
